export default function SignupConfirmation() {
  return (
    <div style={{ textAlign: "center", padding: "2rem", color: "white" }}>
      <img src="/4.webp" alt="Amumu sad" style={{ width: "164px" }} />
      <h2>Email Verification Successful!</h2>
      <p style={{marginBottom: "40px"}}>You can close this tab and return to your signup process</p>
    </div>
  );
}
